/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForAiPromptAnalytics extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForAiPromptAnalytics.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForAiPromptAnalytics>): ProgressDetailsForAiPromptAnalytics {
        let obj = Object.assign(new ProgressDetailsForAiPromptAnalytics(), model);
        ProgressDetailsForAiPromptAnalytics.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForAiPromptAnalytics>): ProgressDetailsForAiPromptAnalytics {
        if (!model) return null;
        return ProgressDetailsForAiPromptAnalytics.newInstance(<ProgressDetailsForAiPromptAnalytics> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForAiPromptAnalytics) {
        if (!obj) return;

        models.ProgressDetailsForAiPromptAnalytics.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForAiPromptAnalytics): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForAiPromptAnalytics.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.last_fetched_time === "string") {
            this.last_fetched_time = new Date(<string><any>this.last_fetched_time);
        }
    }

    /**
     * Datetime for the last processed record
     */
    last_fetched_time: Date;

}
